/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zusatzbogenschuleerhalten2Inputs */

const de__field_zusatzbogenschuleerhalten2 = /** @type {(inputs: _Field_Zusatzbogenschuleerhalten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzbogen Schule erhalten`)
};

/**

* @param {_Field_Zusatzbogenschuleerhalten2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zusatzbogenschuleerhalten2 = /** @type {((inputs?: _Field_Zusatzbogenschuleerhalten2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zusatzbogenschuleerhalten2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zusatzbogenschuleerhalten2(inputs)
});
export { _field_zusatzbogenschuleerhalten2 as "_field_zusatzbogenSchuleErhalten" }